import { Tooltip } from '@mui/material';

import PropTypes from 'prop-types';
import styles from './HeaderImportantInfo.module.css';

const HeaderImportantInfo = ({ icon, text, tooltipText = '' }) => {
    return (
        <Tooltip title={tooltipText} placement="top">
            <div className={styles['important-info--wrapper']}>
                {icon}
                {text}
            </div>
        </Tooltip>
    );
};

HeaderImportantInfo.propTypes = {
    icon: PropTypes.element.isRequired,
    text: PropTypes.string.isRequired,
    tooltipText: PropTypes.string,
};

export default HeaderImportantInfo;
